import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Button from '../../common/Button';

let Form = ({
  handleSubmit,
  onSubmit,
  submitting,
  error,
  okButtonText,
  status,
  t,
}) => (
  <form onSubmit={handleSubmit}>
    <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
      <Field
        component="input"
        type="radio"
        name="status"
        id="ACTIVE"
        className="c-radio"
        value="ACTIVE"
      />
      <label className="u-cursor-pointer" htmlFor="ACTIVE">
        {t('project.edit.involvementStatus.active')}
      </label>
    </div>

    <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
      <Field
        component="input"
        type="radio"
        name="status"
        id="INACTIVE"
        className="c-radio"
        value="INACTIVE"
      />
      <label className="u-cursor-pointer" htmlFor="INACTIVE">
        {t('project.edit.involvementStatus.inactive')}
      </label>
    </div>

    <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
      <Field
        component="input"
        type="radio"
        name="status"
        id="REMOVED"
        className="c-radio"
        value="REMOVED"
      />
      <label className="u-cursor-pointer" htmlFor="REMOVED">
        {t('project.edit.involvementStatus.remove')}
      </label>
    </div>
    {status === 'REMOVED' && (
      <div className="c-radio__descr u-weight-light u-font-italic">
        {t('project.edit.involvementStatus.note')}
      </div>
    )}

    <div className="u-margin-top-huge u-text-center">
      <Button
        className="c-btn-outline c-btn-outline--primary"
        disbaled={submitting ? 1 : 0}
        type="submit"
      >
        {submitting ? t('general.saving') : t('general.save')}
      </Button>
    </div>
    {error && <p className="c-alert c-alert--danger u-margin-top">{error}</p>}
  </form>
);

Form = reduxForm({ form: 'project-edit-status' })(Form);

// Decorate with connect to read form values
const selector = formValueSelector('project-edit-status');
Form = connect((state) => {
  const status = selector(state, 'status');

  return { status };
})(translate()(Form));

export default Form;



// WEBPACK FOOTER //
// ./src/projects/edit-status/Form.js